import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArrowSvgComponent } from './arrow.component';



@NgModule({
  declarations: [
    ArrowSvgComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    ArrowSvgComponent
  ]
})
export class ArrowSvgModule { }
